import { render } from "./DocsCallout.vue?vue&type=template&id=716b7103"
import script from "./DocsCallout.vue?vue&type=script&lang=js"
export * from "./DocsCallout.vue?vue&type=script&lang=js"

import exportComponent from "/Users/aks/Desktop/WORK/Codes/HCL Harit/chatbot-admin-panel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__